import { z } from 'zod'

export const ADMINPERSONAAVATARPOST_CONTRACT_VERSION = '1.0.0' as const
export const adminPersonaAvatarPostResponseSchema = z.unknown()
export type AdminPersonaAvatarPostResponse = z.infer<typeof adminPersonaAvatarPostResponseSchema>
